import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ButtonComponent } from './components/button/button.component';
import { CardComponent } from './components/card/card.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { StatusIndicatorComponent } from './components/status-indicator/status-indicator.component';
import { DateFormatPipe } from './pipes/date-format.pipe';

@NgModule({
  declarations: [ButtonComponent, NotFoundComponent, DateFormatPipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CardComponent,
    StatusIndicatorComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CardComponent,
    StatusIndicatorComponent,
    ButtonComponent,
    NotFoundComponent,
    DateFormatPipe,
  ],
})
export class SharedModule {}
